/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { QuestionModel } from '../../models/question-model';

export interface QuestionnaireInstancePreviousPostParams {
  questionnaireInstanceGuid: string;
  language?: string;
}

export function questionnaireInstancePreviousPost(
  http: HttpClient,
  rootUrl: string,
  params: QuestionnaireInstancePreviousPostParams,
  context?: HttpContext,
): Observable<StrictHttpResponse<QuestionModel>> {
  const rb = new RequestBuilder(
    rootUrl,
    questionnaireInstancePreviousPost.PATH,
    'post',
  );
  if (params) {
    rb.path('questionnaireInstanceGuid', params.questionnaireInstanceGuid, {
      style: 'simple',
    });
    if (params.language) {
      rb.query('languageCode', params.language);
    }
  }

  return http
    .request(rb.build({ responseType: 'json', accept: '*/*', context }))
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<QuestionModel>;
      }),
    );
}

questionnaireInstancePreviousPost.PATH =
  '/api/v1/questionnaire-instances/{questionnaireInstanceGuid}/questions/previous';
